import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

export const updateThreshold = async (threshold) => {
    try {

        const response = await axios.post(`${apiUrl}/sensors/update-threshold`, threshold, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response;
    } catch (error) {
        console.error(`Error al actualizar threshold `, error);
        throw error; // Propaga el error para manejarlo en el componente
    }
}

export const getMeasurements = async (idSensor, idVariable, startDate, endDate) => {
    try {
        const response = await axios.get(`${apiUrl}/sensors/measurements`, {
            params: {
                idSensor,
                idVariable,
                startDate,
                endDate,
                recursive: true,
            },
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response;
    } catch (error) {
        console.error('Error al obtener medidas', error);
        throw error; // Propaga el error para manejarlo en el componente
    }
};
